import React, { useState } from "react";
import Row from "../components/Row";
import Column from "../components/Column";
import TitleUnderlined from "../components/TitleUnderlined";
import SpinnerButton from "../components/SpinnerButton";
import Event from "../models/Event";
import { Link } from "react-router-dom";
import Utils from "../tools/Utils";
import Breadcrumb from "../components/Breadcrumb";
import APIInterface from "../tools/APIInterface";
import TableEvent from "../components/TableEvent";
import { ShimmerText } from "../components/Shimmer";
import Order from "../models/Order";
import Attendee from "../models/Attendee";
import { RoutesWeb } from "../tools/RoutesWeb";
import { REGISTRATION_CLOSED_MESSAGE, TICKET_SALES_ENABLED } from "../tools/registrationFlags";

const EventDetailView = () => {
    const [event, setEvent] = useState(new Event());
    const [isLoaded, setIsLoaded] = useState(false);

    const [ticketsAmount, setTicketsAmount] = useState(0);
    const [order, setOrder] = useState(new Order({attendees:[new Attendee()]}));

    if(event._id === null) {
        if(event._id === null){
            APIInterface.event()
            .then((response) => {
                setEvent(response);
                let newOrder = order;
                newOrder.event_id = response._id;
                newOrder.total = response.price;
                setOrder(newOrder);
                setIsLoaded(true);
            })
            .catch((error) => {
                console.error(error);
            });
        }
    }

    return (
        <div className="pt-5" id="eventDetailView">
            <br></br>
            <br></br>
            <Breadcrumb items={[
                {
                    title: 'Eventos',
                    route: RoutesWeb.HOME
                },
                {
                    title: 'Detalles del evento',
                    active: true
                },
            ]} />
            <Row>
                <Column className="col-md-6">
                    <TitleUnderlined>Detalles del <span className="embercom_overlined">Evento</span></TitleUnderlined>
                    <br />
                    <br />
                    <TableEvent isLoaded={isLoaded} event={event} />
                    <br />
                    {isLoaded ? <p>{event.description}</p> : <ShimmerText line={5} />}
                    {TICKET_SALES_ENABLED ? (
                        <>
                            <span>Seleccione la cantidad de boletos:</span>
                            <SpinnerButton className='mt-2 mb-4' style={{maxWidth: '200px'}} onChange={(res) => {
                                setTicketsAmount(res.value);
                                let rowsData = [];
                                for(let i = 0; i < res.value; i++){
                                    rowsData.push(new Attendee());
                                }
                                let newOrder = order;
                                newOrder.attendees = rowsData;
                                newOrder.total = rowsData.length * parseFloat(event.price);
                                setOrder(newOrder);
                            }} />
                            <Link className="btn btn-main" to={`/detalles/tickets/${Utils.encodeBase64(JSON.stringify(order))}`}>Continuar Proceso <img src={require('../assets/arrow_next.png')} alt="arrowNext" /></Link>
                        </>
                    ) : (
                        <p className="mt-2 mb-0">{REGISTRATION_CLOSED_MESSAGE}</p>
                    )}
                </Column>
                <Column className="col-md-6 d-flex justify-content-center align-items-start">
                    <img src={require('../assets/IMG_Boletos-min-2.png')} alt="Img" style={{width: '100%', maxWidth: '430px'}} />
                    {/* <img src={require('../assets/img2min.png')} alt="Img" style={{width: '100%', maxWidth: '430px'}} /> */}
                </Column>
            </Row>
        </div>
    )
}

export default EventDetailView;